import { render, staticRenderFns } from "./TaskDraftNote.vue?vue&type=template&id=2dfcf272&scoped=true"
import script from "./TaskDraftNote.vue?vue&type=script&lang=js"
export * from "./TaskDraftNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfcf272",
  null
  
)

export default component.exports